import { render, staticRenderFns } from "./PresentationName.vue?vue&type=template&id=35016ca5&scoped=true"
import script from "./PresentationName.vue?vue&type=script&lang=js"
export * from "./PresentationName.vue?vue&type=script&lang=js"
import style0 from "./PresentationName.vue?vue&type=style&index=0&id=35016ca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35016ca5",
  null
  
)

export default component.exports